<template>
  <div class="flex justify-between items-end">
    <FormGroup
      class="mt-0"
      label="Min price"
    >
      <TextField
        id="input-min-price"
        ref="inputMinPrice"
        type="number"
        inputmode="numeric"
        pattern="\d*"
        placeholder="0"
        :model-value="value[0]"
        :prefix="currencySign"
        :max="1000000"
        @update:modelValue="input('min', $event)"
        @change="$emit('change')"
      />
    </FormGroup>
    <div class="dash">
      -
    </div>
    <FormGroup
      class="mt-0"
      label="Max price"
    >
      <TextField
        id="input-max-price"
        ref="inputMaxPrice"
        type="number"
        inputmode="numeric"
        pattern="\d*"
        :model-value="value[1]"
        :placeholder="placeholderMax"
        :prefix="currencySign"
        :max="1000000"
        @update:modelValue="input('max', $event)"
        @change="$emit('change')"
      />
    </FormGroup>
  </div>
</template>

<script>
import FormGroup from '@/components/Ui/Forms/FormGroup.vue';
import TextField from '@/components/Ui/Forms/TextField.vue';
import inputHandlers from '@/services/inputHandlers';

export default {
  name: 'PriceInputs',
  emits: ['input', 'change'],
  components: { FormGroup, TextField },
  props: {
    value: {
      type: Array,
      required: true,
      validator: val => val.length === 2,
    },
    placeholderMax: {
      type: String,
      default: '10000+',
    },
    currencySign: {
      type: String,
      required: true,
    },
  },

  methods: {
    input(field, value) {
      this.$emit('input', { field, value });
    },
  },

  mounted() {
    inputHandlers.number(this.$refs.inputMinPrice.$el);
    inputHandlers.number(this.$refs.inputMaxPrice.$el);
  },
};
</script>

<style lang="scss" scoped>
.dash {
  margin: 10px;
}

.mt-0.mt-0 {
  margin-top: 0;
}
</style>
